.header {
  text-align: center;
  font-size: 20px;
  color: #142F43;
  font-weight: 500;
}